import styled from 'styled-components';

export default styled.div`
  width: 100%;
  float: left;
  font-size: 3.6rem;
  color: #3F3F40;
  margin-top: 2rem;
`;
